<div id="user-group-container" style="position: relative;" data-cy="user-groups-container">
  <app-tdo-progress-spinner *ngIf="isLoading" style="margin-left: auto; margin-right: auto; position: absolute; top: 50%; left: 50%;" diameter="100" mode="indeterminate" data-cy="user-groups-loading-spinner"></app-tdo-progress-spinner>
  <mat-grid-list *ngIf="!isLoading" cols="7" rowHeight="100%" style="height:100%;" data-cy="user-groups-grid">
    <mat-grid-tile colspan="2" data-cy="user-groups-list-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="user-groups-list-card">
        <span class="configuration-section-title" data-cy="user-groups-list-title">Groups</span>
        <div style="height: 54px;" data-cy="user-groups-client-container">
          <tdo-dropdown-v2 widthString="100%" placeholder="Practice (Licensee)" [value]="selectedClient" placeholderPosition="above" [datasource]="clientList" displayProperty="Name" (selectionChange)="onChangeClient($event.value)" data-cy="user-groups-client-dropdown"></tdo-dropdown-v2>
        </div>
        <!--<mat-form-field style="width:100%; margin-top: 3px;">
          <mat-label>Practice (Licensee)</mat-label>
          <mat-select [(value)]="selectedClient" (selectionChange)="onChangeClient($event)">
            <mat-option *ngFor="let client of clientList" [value]="client">
              {{client.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>-->
        <div style="height: calc(100% - 100px)" data-cy="user-groups-table-container">
          <!--<app-tdo-table #groupTable [tdoTableModel]="tableModel" sortActive="UserGroupName" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)"></app-tdo-table>-->
          <tdo-table #groupTable [dataSource]="groups" (rowSelected)="onGroupSelection($event)" data-cy="user-groups-table">
            <tdo-table-column displayName="Group Name" propertyName="UserGroupName" [rowTemplate]="name" data-cy="user-groups-name-column">
              <ng-template #name let-row>
                <div data-cy="user-groups-name-{{row.index}}">{{row.UserGroupName}}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="del" data-cy="user-groups-delete-column">
              <ng-template #del let-row>
                <div style="width: 20px; margin-left: auto; margin-right: 0; color: var(--tdo-secondary); cursor: pointer;" (click)="deleteUserGroup(row.model)" [matTooltip]="'Delete ' + row.model.UserGroupName + '?'" data-cy="user-groups-delete-button-{{row.index}}">
                  <mat-icon>delete</mat-icon>
                </div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" data-cy="user-groups-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="user-groups-detail-card">
        <div style="max-width: 700px;" data-cy="user-groups-detail-container">
          <span class="configuration-section-title" data-cy="user-groups-detail-title">Group Settings</span>
          <app-tdo-configuration-action-bar [saveDisabled]="editedGroups.length == 0" (newClick)="onNew($event)" (saveClick)="onSave($event)" data-cy="user-groups-action-bar"></app-tdo-configuration-action-bar>
          <div *ngIf="selectedGroup" style="display: flex;" data-cy="user-groups-form-container">
            <div style="flex: 1;" data-cy="user-groups-form-left">
              <div class="user-group-row" *ngIf="selectedGroup" data-cy="user-groups-name-field">
                <!--<span style="text-align: right; flex-basis: 130px; margin-right: 10px;">
                  User Group Name
                </span>
                <input style="flex: 1;" [(ngModel)]="selectedGroup.UserGroupName" (ngModelChange)="onModelChange()" />-->
                <mat-form-field style="width:100%; margin-top: 6px;" data-cy="user-groups-name-form-field">
                  <mat-label data-cy="user-groups-name-label">User Group Name:</mat-label>
                  <!--<input matInput  placeholder="User Name"  />-->
                  <input matInput placeholder="User Group Name" [ngModel]="selectedGroup.UserGroupName" (ngModelChange)="onModelChange($event); configurationService.setDirty();" data-cy="user-groups-name-input" />
                </mat-form-field>
              </div>
              <div class="user-group-row" *ngIf="selectedGroup" data-cy="user-groups-type-field">
                <div style="flex: 1;" data-cy="user-groups-type-container">
                  <app-validvalueselect style="position: relative;  width: 100%;"
                                        vvplaceholder="User Group Type:"
                                        validvaluename="enumUserGroupType"
                                        (selectedValueChange)="onUserGroupChange($event)"
                                        [selectedValue]="selectedGroup.enumUserGroupTypeID"
                                        [dataSource]="userGroupTypeEnums"
                                        data-cy="user-groups-type-dropdown">
                  </app-validvalueselect>
                </div>
              </div>

             
              


              <div data-cy="user-groups-roles-container">
                <div data-cy="user-groups-roles-title">Roles</div>
                <div *ngIf="userRoles" style="margin-bottom: 10px; width: 100%; display: flex; flex-direction: column; border: 2px solid rgba(0,0,0,0.05); border-radius: 6px; padding: 3px; max-height: 600px; overflow-y: auto;" data-cy="user-groups-roles-list">
                  <div *ngFor="let role of userRoles; let i = index" data-cy="user-groups-role-item-{{i}}">
                    <mat-checkbox style="height: 24px;" [checked]="isChecked(role)" (change)="onRoleChange($event, role)" data-cy="user-groups-role-checkbox-{{i}}">{{role.RoleName}}<mat-icon style="position: relative; top: 6px; color: var(--tdo-secondary);" [matTooltip]="role.Description" data-cy="user-groups-role-help-{{i}}">help</mat-icon></mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex: 1;" data-cy="user-groups-form-right">

            </div>
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
